import Location from "../../assats/location.webp";
import instagram from "../../assats/Instagram.webp";
import facebook from "../../assats/Facebook.webp";
import linkedin from "../../assats/LinkedIn.webp";
import youtube from "../../assats/youtube.webp";
import Logo from "../../assats/logo.webp";
import LineImg from "../../assats/line.png";
import HomeIcon from "../../assats/Homeicon.png";
import EmailIcon from "../../assats/emailiconf.png";
import CallIcon from "../../assats/calliconf.png";
import gallary1 from "../../assats/gallary1.webp";
import gallary2 from "../../assats/gallary2.webp";
import gallary3 from "../../assats/gallary3.webp";
import gallary4 from "../../assats/gallary4.webp";
import borderImg from "../../assats/border.png";
import { useEffect, useState } from "react";
import { API_URL } from "../../config";
import axios from "axios";
import { useNavigate } from "react-router-dom";


const Footer = () => {
    const navigate = useNavigate();
    const phoneNumber = '+91 9327286102';
    const emailAddress = 'info@designcore.co.in';
    const [latestPost, setLatestPost] = useState([]);


    const recentPostData = () => {
        const url = `${API_URL}/admin/post/view_recent_post`;

        axios.get(url)
            .then(response => {
                setLatestPost(response.data.record);
            })
            .catch(error => {
                // Handle error
                console.error("Error:", error.response.status, error.response.statusText);
                console.error(error.response.data);
            });
    }
    useEffect(() => {
        recentPostData();
    }, [])

    return (
        <>
            {/* <div className="flex flex-col bg-[#fff] bottom-5">
                <p className="text-center text-[20px] font-semibold py-8">DesignCore Studio</p>
                <p className="text-center pb-2">info@designcore.co.in</p>
                <p className="text-center pb-2">+91 93272 86102</p>
                <p className="text-center pb-2">310/311 Union Heights, Maharana Pratap Marg, RahulRaj Mall Lane, Piplod, Surat, Gujarat 395007, India</p>
                <div className="flex justify-center space-x-2">
                    <img src={Location} alt="Location" className=" cursor-pointer" />
                    <img src={instagram} alt="instagram" className=" cursor-pointer" />
                    <img src={facebook} alt="facebook" className=" cursor-pointer" />
                    <img src={linkedin} alt="linkedin" className=" cursor-pointer" />
                    <img src={youtube} alt="youtube" className=" cursor-pointer" />
                </div>
                <p className="py-8 text-center">©2024 by DesignCore Studio.</p>
            </div> */}
            {/* <div className="bg-[#A35733] py-20" >
                <div className="container md:mx-auto grid grid-cols-4">
                    <div>
                        <div className="flex space-x-2 mb-3 ml-2">
                            <p className="text-white text-[20px]">ADDRESS</p>
                            <img src={LineImg} className="h-0.5 mt-3.5" />
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={Location} />
                            <p className="text-white">123 Street, New York, USA</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={instagram} />
                            <p className="text-white">+012 345 67890</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={facebook} />
                            <p className="text-white">mail@domain.com</p>
                        </div>
                        <div className="flex space-x-3 mt-5 ml-2">
                            <div className="border border-slate-400 p-2  rounded-full hover:bg-[#fff] cursor-pointer">
                                <img src={facebook} />
                            </div>
                            <div className="border border-slate-400 p-2  rounded-full hover:bg-[#fff] cursor-pointer">
                                <img src={instagram} />
                            </div>
                            <div className="border border-slate-400 p-2  rounded-full hover:bg-[#fff] cursor-pointer">
                                <img src={linkedin} />
                            </div>
                            <div className="border border-slate-400 p-2  rounded-full hover:bg-[#fff] cursor-pointer">
                                <img src={Location} />
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="flex space-x-2 mb-3 ml-2">
                            <p className="text-white text-[20px]">QUICK LINK</p>
                            <img src={LineImg} className="h-0.5 mt-3.5" />
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={Location} />
                            <p className="text-white">About Us</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={instagram} />
                            <p className="text-white">+Contact Us</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={facebook} />
                            <p className="text-white">Project</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={facebook} />
                            <p className="text-white">FAQ</p>
                        </div>
                    </div>
                    <div>
                        <div className="flex space-x-2 mb-3 ml-2">
                            <p className="text-white text-[20px]">GALLARY</p>
                            <img src={LineImg} className="h-0.5 mt-3.5" />
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={Location} />
                            <p className="text-white">123 Street, New York, USA</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={instagram} />
                            <p className="text-white">+012 345 67890</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={facebook} />
                            <p className="text-white">mail@domain.com</p>
                        </div>
                    </div>
                    <div>
                        <div className="flex space-x-2 mb-3 ml-2">
                            <p className="text-white text-[20px]">CONTACT US</p>
                            <img src={LineImg} className="h-0.5 mt-3.5" />
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={Location} />
                            <p className="text-white">123 Street, New York, USA</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={instagram} />
                            <p className="text-white">+012 345 67890</p>
                        </div>
                        <div className="flex space-x-2 mb-2">
                            <img src={facebook} />
                            <p className="text-white">mail@domain.com</p>
                        </div>
                    </div>

                </div>

            </div> */}

            <div className=" bg-white drop-shadow-2xl mt-10">
                <footer class="container md:mx-auto text-center text-lg-start text-muted py-10 px-10">
                    <section class="">
                        <div class="container text-center text-md-start mt-5">
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                <div class="mb-4">
                                    <img src={Logo} alt="logo" className="m-auto mb-3" />
                                    <h6 class="text-uppercase font-bold mb-4 text-[18px]">
                                        Designcore Studio
                                    </h6>
                                    <p className="text-start">
                                        DesignCore Studio was co-founded by Ar. Manish Choksi & Ar. Urvi Choksi in 1991. Since then, we have grown into a family of creative and innovative designers who are committed to excellence and unparalleled design.
                                    </p>
                                </div>

                                <div class="mb-4">
                                    <p class="text-uppercase font-bold mt-4 text-[18px] ">
                                        Useful links
                                    </p>
                                    <img src={borderImg} className="mb-4 h-0.5 w-32 m-auto" />

                                    <p className="mb-3">
                                        <a href="/" class="hover:text-gray-500">Home</a>
                                    </p>
                                    <p className="mb-3">
                                        <a href="/about-us" class="hover:text-gray-500">About Us</a>
                                    </p>
                                    <p className="mb-3">
                                        <a href="/projects" class="hover:text-gray-500">Projects</a>
                                    </p>
                                    <p className="mb-3">
                                        <a href="/faq" class="hover:text-gray-500">FAQ</a>
                                    </p>
                                    <p className="mb-3">
                                        <a href="/contact" class="hover:text-gray-500">Contact</a>
                                    </p>
                                </div>
                                <div className="mb-4">
                                    <p class="text-uppercase font-bold mt-4 text-[18px]">
                                        Latest
                                    </p>
                                    <img src={borderImg} className="mb-4 h-0.5 w-20 m-auto" />
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 px-16 gap-2">
                                        {latestPost.map((item) => {
                                            return (
                                                <div onClick={() => navigate(`/detail/${item._id}`)} className="cursor-pointer">
                                                    <img src={`${API_URL}${item?.postImage}`} alt="" className="w-24 h-24 rounded-lg m-auto" />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className="mb-4 space-y-5">
                                    <div>
                                        <p class="text-uppercase font-bold mt-4 text-[18px]">
                                            Conatct
                                        </p>
                                        <img src={borderImg} className="mb-4 h-0.5 w-28 m-auto" />
                                    </div>
                                    <div className="flex">
                                        <img src={HomeIcon} className="w-8 h-8 " />
                                        <a className="cursor-pointer" href="https://www.google.com/maps?cid=4193855031504713995">310/311 Union Heights, Maharana Pratap Marg,RahulRaj Mall Lane, Piplod, Surat, Gujarat 395007, India  </a>
                                    </div>
                                    <div className="flex">
                                        <img src={EmailIcon} className="w-8 h-8" />
                                        <a href={`mailto:${emailAddress}`} className="pl-7 pt-1">
                                            {emailAddress}
                                        </a>
                                    </div>
                                    <div className="flex">
                                        <img src={CallIcon} className="w-8 h-8" />
                                        <a href={`tel:${encodeURIComponent(phoneNumber)}`} className="pl-7 pt-0.5">
                                            {phoneNumber}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="text-center p-4">
                        <a class="font-bold text-black hover:text-gray-300">©2024 by DesignCore Studio.</a>
                    </div>
                </footer>
            </div >
        </>
    )
}
export default Footer;